import { render } from "./stellar.vue?vue&type=template&id=0028d800&ts=true"
import script from "./stellar.vue?vue&type=script&lang=ts"
export * from "./stellar.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__